/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ datasetId: ZodTypes.Id });
export const AdminDatasetVerifyPost = {
  id: 'admin-dataset-verify.post',
  tag: 'Admin',
  summary: 'Admin Verify Dataset',
  description: 'Verify dataset',
  method: 'post',
  flags: { isAuthorized: true, isSuperuser: true },
  route: (params: z.infer<typeof Params>) => `/administration/dataset/${params.datasetId}/verify`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
